import React, { useEffect, useState } from "react";
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  TableContainer,
  Paper,
  Box,
  MenuItem,
  Pagination,
  Select,
  Typography,
  Menu,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import ValidateModal from "./ValidateModal";
import Swal from "sweetalert2";
import CheckMarkValid from "../Assets/CheckMarkValid.png";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import { toast } from "react-toastify";

const useStyles = makeStyles(() => ({
  evenRow: {
    backgroundColor: "#D0EFFF",
  },
  oddRow: {
    backgroundColor: "#FFFFFF",
  },
}));

const CmsApprovelLists = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);


  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMerchantId, setSelectedMerchantId] = useState(null);
  const open = Boolean(anchorEl);


    const handleClick = (event, merchantId) => {
      setAnchorEl(event.currentTarget);
      setSelectedMerchantId(merchantId);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

const handleViewDocs = async (docType) => {
  handleClose();
  console.log("Viewing", docType, "for", selectedMerchantId);
  try {
    const token = sessionStorage.getItem("jwtToken");
    const response = await axios.get(
      `https://api.ipaisa.co.in/myapp/cms/download/${selectedMerchantId}/${docType}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }
    );

    const contentType = response.headers["content-type"] || "application/pdf";
    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
  } catch (error) {
    console.error(error);
    toast.error(`Failed to fetch ${docType}`);
  }
};



  const handleValidate = (userId) => {
    setSelectedUserId(userId);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };



  // Fetch data froxm API
  const fetchData = async () => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.get(
        "https://api.ipaisa.co.in/myapp/admin/getCmsApplications",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.statusCodeValue === 200) {
        setData(response.data.body.data);
        setTotalRecords(response.data.body.totalRecords);
      } else {
        setData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  // Handle Apply button click
  const handleApply = async (userId) => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.post(
        "https://api.ipaisa.co.in/myapp/admin/applyMerchantOnboarding",
        { userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Show success SweetAlert
      if (response.data.statusCodeValue === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.body.message,
        });
        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response.data.body.message,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.body?.message,
      });
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value - 1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setCurrentPage(0);
  };


  return (
    <Box style={{ padding: "2rem", marginTop: "calc(3% + 56px)" }}>
      <Grid style={{ marginTop: "3%" }}>
        <TableContainer
          component={Paper}
          sx={{
            maxWidth: "100%",
            overflowX: "auto",
            borderRadius: "12px 12px 0px 0px",
          }}
        >
          <Table>
            <TableHead style={{ backgroundColor: "#027BFE", color: "white" }}>
              <TableRow>
                <TableCell style={{ color: "white" }}>Sr No.</TableCell>
                <TableCell style={{ color: "white" }}>Name</TableCell>
                <TableCell style={{ color: "white" }}>User ID</TableCell>
                <TableCell style={{ color: "white" }}>Merchant ID</TableCell>
                <TableCell style={{ color: "white" }}>Shop City</TableCell>
                <TableCell style={{ color: "white" }}>Phone Number</TableCell>
                <TableCell style={{ color: "white" }}>Email</TableCell>
                <TableCell style={{ color: "white" }}>Company Name</TableCell>
                <TableCell style={{ color: "white" }}>View Docs</TableCell>
                <TableCell align="center" style={{ color: "white" }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Typography variant="h6" color="textSecondary">
                      No applications found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                data.map((item, index) => (
                  <TableRow
                    key={item.id}
                    className={
                      index % 2 === 0 ? classes.oddRow : classes.evenRow
                    }
                  >
                    <TableCell>{currentPage * pageSize + index + 1}</TableCell>
                    <TableCell>
                      {item.firstName} {item.lastName}
                    </TableCell>
                    <TableCell>{item.user?.userid}</TableCell>
                    <TableCell>{item.merchantLoginId}</TableCell>
                    <TableCell>{item.shopCity}</TableCell>
                    <TableCell>{item.merchantPhoneNumber}</TableCell>
                    <TableCell>{item.emailId}</TableCell>
                    <TableCell>{item.companyLegalName}</TableCell>
                    <TableCell
                      onClick={(e) => handleClick(e, item.merchantLoginId)}
                    >
                      <IconButton>
                        <ContentPasteSearchIcon />
                      </IconButton>
                    </TableCell>

                    <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                      {[
                        "pan",
                        "aadhar",
                        "shopPan",
                        "certificateOfIncorporation",
                        "tradeBusinessProof",
                      ].map((doc) => (
                        <MenuItem key={doc} onClick={() => handleViewDocs(doc)}>
                          {doc}
                        </MenuItem>
                      ))}
                    </Menu>

                    <TableCell align="center">
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <Button
                          variant="outlined"
                          sx={{
                            textTransform: "none",
                            backgroundColor: "#4CAF50",
                            color: "white",
                            "&:hover": {
                              backgroundColor:
                                item.adminVerification !== "TRUE"
                                  ? "#45a049"
                                  : "#4CAF50",
                            },
                            "&:disabled": {
                              backgroundColor: "#BDBDBD",
                              color: "#757575",
                            },
                          }}
                          onClick={() => handleValidate(item.user?.userid)}
                          disabled={item.adminVerification === "TRUE"}
                        >
                          {item.adminVerification === "TRUE"
                            ? "Validated"
                            : "Validate"}
                        </Button>

                        <Button
                          variant="outlined"
                          sx={{
                            textTransform: "none",
                            backgroundColor: "#2196F3",
                            color: "white",
                            "&:hover": {
                              backgroundColor:
                                item.adminVerification === "TRUE"
                                  ? "#1e88e5"
                                  : "#2196F3",
                            },
                            "&:disabled": {
                              backgroundColor: "#BDBDBD",
                              color: "#757575",
                            },
                          }}
                          onClick={() => handleApply(item.user?.userid)}
                          disabled={item.adminVerification !== "TRUE"}
                        >
                          Apply
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>

            {/* Modal */}
            <ValidateModal
              fetchData={fetchData}
              open={modalOpen}
              onClose={handleCloseModal}
              onValidate={handleValidate}
              userId={selectedUserId}
            />
          </Table>
        </TableContainer>
      </Grid>
      {/* Pagination */}
      <Grid
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        style={{ marginTop: "1%" }}
      >
        <Grid item>
          <Select
            variant="outlined"
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
          <Typography display="inline" style={{ marginLeft: 8 }}>
            Showing {currentPage * pageSize + 1} to{" "}
            {Math.min((currentPage + 1) * pageSize, totalRecords)} out of{" "}
            {totalRecords} records
          </Typography>
        </Grid>
        <Grid item>
          <Pagination
            count={Math.ceil(totalRecords / pageSize)}
            color="primary"
            page={currentPage + 1}
            onChange={handlePageChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CmsApprovelLists;
